import {
    useEffect,
    useState,
} from 'react';

import {
    useDispatch,
    useSelector,
} from 'react-redux';
import { PermissionAction } from 'src/actions/permission.acction';

import {
    Button,
    Checkbox,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControl,
    FormControlLabel,
    FormGroup,
    TextField,
    Typography,
    Grid,
    Box,
    Select as Select1,
    InputAdornment,
    SvgIcon,
    MenuItem,
} from '@material-ui/core';

import ReactSelect from 'react-select';

import { Search as SearchIcon } from 'react-feather';

import {
    DatePicker,
    LocalizationProvider,
  } from '@mui/x-date-pickers';
  import {
    DEFAULT_ROW_PER_PAGE,
    LOAI_GOI_CUOC,
    POST_EDITOR_FONTS,
    POST_EDITOR_FONT_SIZES,
    OPERATOR_THEME,
    CU_PHAP_DANG_KY_GOI_CUOC,
    MAXIMUM_IMAGES,
  } from 'src/utils/constants';
  import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import moment from 'moment';

import { Helmet } from "react-helmet";

import numeral from 'numeral';

import PostEditor from "../../components/PostEditor";
import ImageUploader from "../../components/ImageUploader";
import { LocationAction } from 'src/actions/location.action';
import { ProductAction } from 'src/actions/product.action';

const ProductOrderDialog = (props) => {
    const maximumImages = MAXIMUM_IMAGES;
    const dispatch = useDispatch()
    const [selectedPermissionIds, setSelectedPermissionIds] = useState([]);
    const { role } = useSelector(state => state.profile);
    const { items } = useSelector(state => state.permission)
    const { homepageProductSelected } = useSelector(state => state.product)

    const [provinces, setProvinces] = useState([]);
    const [districts, setDistricts] = useState([]);
    const [wards, setWards] = useState([]);
    const [itemId, setItemId] = useState("");
    const [name, setName] = useState("");
    const [image, setImage] = useState("");
    const [price, setPrice] = useState("");
    const [price_new, setPriceNew] = useState("");
    const [operator, setOperator] = useState("");
    const [operator1, setOperator1] = useState("");
    const [time_by_month, setTimeByMonth] = useState("");
    const [description, setDescription] = useState("");
    const [tinh_trang, setTinhTrang] = useState("");
    const [tinh_trang_color, setTinhTrangColor] = useState("");
    const [images, setImages] = useState([]);

    const [formData, setFormData] = useState({
        name: "",
        phone: "",
        email: "",
        province: "-99",
        province_name: "",
        district: "-99",
        district_name: "",
        ward: "-99",
        ward_name: "",
        address: "",
        note: "",
        paymentMethod: "cod",
        quantity: 1,
        itemId,
    });

    useEffect(() => {
        console.log(homepageProductSelected);

        setItemId('');
        setName('');
        setImage('');
        setPrice('');
        setPriceNew('');
        setOperator('');
        setTimeByMonth('');
        setDescription('');
        setTinhTrang('');
        setTinhTrangColor('');
        setImages([]);

        if (homepageProductSelected) {
            setFormData({
                ...formData,
                itemId: homepageProductSelected.slug ? homepageProductSelected.slug : '',
            });

            setItemId(homepageProductSelected.slug ? homepageProductSelected.slug : '');
            setName(homepageProductSelected.name ? homepageProductSelected.name : '');
            setImage(homepageProductSelected.image ? homepageProductSelected.image : '');
            setPrice(homepageProductSelected.price ? Number(homepageProductSelected.price) : '0');
            setPriceNew(homepageProductSelected.price_new ? Number(homepageProductSelected.price_new) : '0');
            setOperator(homepageProductSelected.operator)
            setOperator1(homepageProductSelected.operator == "MOBIFONE" ? "-160px 3px" : (homepageProductSelected.operator == "VINAPHONE" ? "-80px 3px" : "0px 3px"))
            setTimeByMonth(homepageProductSelected.time_by_month ? numeral(homepageProductSelected.time_by_month).format('0,0') + ' tháng' : '0 tháng');
            setDescription(homepageProductSelected.description ? homepageProductSelected.description : '');

            setTinhTrang(homepageProductSelected.trang_thai == 'con_hang' ? 'Còn hàng' : (homepageProductSelected.trang_thai == 'giu_so' ? '' : 'Hết hàng'))
            setTinhTrangColor(homepageProductSelected.trang_thai == 'con_hang' ? 'green' : (homepageProductSelected.trang_thai == 'giu_so' ? 'orange' : 'red'))

            const _images = [];
            for (let i = 0; i < maximumImages; i++) {
                const key = i === 0 ? 'image' : `image${i}`;
                if (typeof homepageProductSelected[key] !== 'undefined' && homepageProductSelected[key]) {
                    _images.push(homepageProductSelected[key]);
                }
            }

            setImages(_images);
            
            async function fetchData() {
                try {
                    let getProvinces = await dispatch(LocationAction.getProvinces());
                    console.log(getProvinces);
                    setProvinces(getProvinces);
                } catch (error) {
                    console.error(error);
                }
            }

            fetchData();
        }
    }, [homepageProductSelected])

    useEffect(() => {
        async function fetchData() {
            try {
                setFormData({ 
                    ...formData, 
                    ward: "-99", 
                    ward_name: "", 
                });
                setWards([]);
                let getWards = await dispatch(LocationAction.getWardsByDistrict(formData.district));
                console.log(getWards);
                setWards(getWards);
            } catch (error) {
                console.error(error);
            }
        }

        fetchData();
    }, [formData.province, formData.district])

    useEffect(() => {
        async function fetchData() {
            try {
                setFormData({ 
                    ...formData, 
                    district: "-99",
                    district_name: "", 
                });
                setDistricts([]);
                let getDistricts = await dispatch(LocationAction.getDistrictsByProvince(formData.province));
                console.log(getDistricts);
                setDistricts(getDistricts);
            } catch (error) {
                console.error(error);
            }
        }

        fetchData();
    }, [formData.province])

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleChange1 = (key, value, key1 = null, value1 = null) => {
        if (key1 && value1) {
            setFormData({ 
                ...formData, 
                [key]: value,
                [key1]: value1,
            });
        } else {
            setFormData({ 
                ...formData, 
                [key]: value 
            });
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        dispatch(ProductAction.sendOrder({...formData, priceIndex: props.priceIndex}));
    };

    return (<>
        <Helmet>
            <style>{`
                .otp-close-btn {
                    position: absolute;
                    top: 12px;
                    right: 12px;
                    background-color: red;
                    color: white;
                    border: none;
                    border-radius: 50%;
                    width: 32px;
                    height: 32px;
                    font-size: 20px;
                    font-weight: bold;
                    line-height: 32px;
                    text-align: center;
                    cursor: pointer;
                    z-index: 10;
                }
  
                .otp-container {
                    width: 100%;
                    max-width: 480px;
                    margin: auto;
                    /* padding: 16px; */
                    box-sizing: border-box;
                    font-family: Mulish, sans-serif;
                }
            `}</style>
        </Helmet>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <Dialog style={{zIndex: 999999}} open={props.open} onClose={props.handleClose}>
                {/* <DialogTitle>{props.type === 'EDIT' ? "Cập nhật bản ghi" : "Tạo bản ghi mới"}</DialogTitle> */}
                <DialogContent className='order_container'>
                    <div className="otp-container">
                        {/* Nút đóng */}
                        <button className="otp-close-btn" onClick={props.handleClose}>
                            &times;
                        </button>
                        {name && homepageProductSelected && homepageProductSelected.trang_thai == 'con_hang' && <>
                            <div style={{color: '#FF0000', fontSize: '24px', fontWeight: 'bold', padding: "0 0 20px 0"}}>THÔNG TIN ĐẶT HÀNG</div>
                            <form className='form-dat-hang' onSubmit={(e) => {handleSubmit(e); props.handleClose(); }} style={{ display: "grid", gap: "15px", padding: "0" }}>
                                <div>
                                    <label>Số lượng <span style={{color: 'var(--main-color)'}}>*</span>:</label>
                                    <input type="text" name="quantity" value={formData.quantity} onChange={handleChange} required style={{ width: "100%", padding: "10px", border: "1px solid #ddd", borderRadius: "5px" }} />
                                </div>
                                <div>
                                    <label>Họ và tên <span style={{color: 'var(--main-color)'}}>*</span>:</label>
                                    <input type="text" name="name" value={formData.name} onChange={handleChange} required style={{ width: "100%", padding: "10px", border: "1px solid #ddd", borderRadius: "5px" }} />
                                </div>
                                <div>
                                    <label>Số điện thoại <span style={{color: 'var(--main-color)'}}>*</span>:</label>
                                    <input type="text" name="phone" value={formData.phone} onChange={handleChange} required style={{ width: "100%", padding: "10px", border: "1px solid #ddd", borderRadius: "5px" }} />
                                </div>
                                {/* <div>
                                    <label>Email <span style={{color: 'var(--main-color)'}}>*</span>:</label>
                                    <input type="email" name="email" value={formData.email} onChange={handleChange} required style={{ width: "100%", padding: "10px", border: "1px solid #ddd", borderRadius: "5px" }} />
                                </div> */}
                                <div>
                                    <label>Tỉnh/thành:</label>
                                    <div style={{ width: '100%', zIndex: '10', marginTop: 0 }} className="full-width-select">
                                        <ReactSelect
                                            classNamePrefix="nt-select"
                                            menuPortalTarget={document.body}
                                            styles={{
                                                menuPortal: base => ({
                                                    ...base,
                                                    zIndex: 999999,
                                                }),
                                                control: (provided) => ({
                                                    ...provided,
                                                    height: 37,
                                                }),
                                                option: (provided) => ({
                                                    ...provided,
                                                }),
                                            }}
                                            options={[
                                                { code: '-99', name: 'Chọn tỉnh/thành' },
                                                ...provinces
                                            ]}
                                            getOptionLabel={(item) => `${item.name}`}
                                            placeholder={formData.province_name || "Chọn tỉnh/thành..."}
                                            components={{
                                                DropdownIndicator: () => <SearchIcon size={16} color="action" />,
                                                IndicatorSeparator: null,
                                            }}
                                            value={formData.province || null}
                                            onChange={(newValue) => {
                                                handleChange1('province', newValue.code, 'province_name', newValue.name);
                                            }}
                                            isSearchable
                                        />
                                    </div>
                                </div>
                                <div>
                                    <label>Quận/huyện:</label>
                                    <div style={{ width: '100%', zIndex: '10', marginTop: 0 }} className="full-width-select">
                                        <ReactSelect
                                            classNamePrefix="nt-select"
                                            menuPortalTarget={document.body}
                                            styles={{
                                                menuPortal: base => ({
                                                    ...base,
                                                    zIndex: 999999,
                                                }),
                                                control: (provided) => ({
                                                    ...provided,
                                                    height: 37,
                                                }),
                                                option: (provided) => ({
                                                    ...provided,
                                                }),
                                            }}
                                            options={[
                                                { code: '-99', name: 'Chọn quận/huyện' },
                                                ...districts
                                            ]}
                                            getOptionLabel={(item) => `${item.name}`}
                                            placeholder={formData.district_name || "Chọn quận/huyện..."}
                                            components={{
                                                DropdownIndicator: () => <SearchIcon size={16} color="action" />,
                                                IndicatorSeparator: null,
                                            }}
                                            value={formData.district || null}
                                            onChange={(newValue) => {
                                                handleChange1('district', newValue.code, 'district_name', newValue.name);
                                            }}
                                            isSearchable
                                        />
                                    </div>
                                </div>
                                <div>
                                    <label>Phường/xã:</label>
                                    <div style={{ width: '100%', zIndex: '10', marginTop: 0 }} className="full-width-select">
                                        <ReactSelect
                                            classNamePrefix="nt-select"
                                            menuPortalTarget={document.body}
                                            styles={{
                                                menuPortal: base => ({
                                                    ...base,
                                                    zIndex: 999999,
                                                }),
                                                control: (provided) => ({
                                                    ...provided,
                                                    height: 37,
                                                }),
                                                option: (provided) => ({
                                                    ...provided,
                                                }),
                                            }}
                                            options={[
                                                { code: '-99', name: 'Chọn phường/xã' },
                                                ...wards
                                            ]}
                                            getOptionLabel={(item) => `${item.name}`}
                                            placeholder={formData.ward_name || "Chọn phường/xã..."}
                                            components={{
                                                DropdownIndicator: () => <SearchIcon size={16} color="action" />,
                                                IndicatorSeparator: null,
                                            }}
                                            value={formData.ward || null}
                                            onChange={(newValue) => {
                                                handleChange1('ward', newValue.code, 'ward_name', newValue.name);
                                            }}
                                            isSearchable
                                        />
                                    </div>
                                </div>
                                <div>
                                    <label>Địa chỉ chi tiết <span style={{color: 'var(--main-color)'}}>*</span>:</label>
                                    <input type="text" name="address" value={formData.address} onChange={handleChange} required style={{ width: "100%", padding: "10px", border: "1px solid #ddd", borderRadius: "5px" }} />
                                </div>
                                <div>
                                    <label>Ghi chú (nếu có):</label>
                                    <input type="text" name="note" value={formData.note} onChange={handleChange} style={{ width: "100%", padding: "10px", border: "1px solid #ddd", borderRadius: "5px" }} />
                                </div>
                                <div>
                                    <div style={{ display: "flex", gap: "10px" }}>
                                        <label>
                                            <input type="radio" name="paymentMethod" value="cod" checked={formData.paymentMethod === "cod"} onChange={handleChange} /> COD
                                        </label>
                                        <label>
                                            <input type="radio" name="paymentMethod" value="online" checked={formData.paymentMethod === "online"} onChange={handleChange} /> Chuyển khoản
                                        </label>
                                    </div>
                                </div>
                                <button type="submit" style={{ marginTop: "10px", padding: "10px", background: "var(--main-color)", color: "#fff", border: "none", borderRadius: "5px", cursor: "pointer", fontSize: "16px", fontWeight: "bold", transition: "0.3s" }}
                                    onMouseEnter={(e) => e.target.style.background = "var(--main-color)"}
                                    onMouseLeave={(e) => e.target.style.background = "var(--main-color)"}>
                                    Đặt hàng
                                </button>
                            </form>
                        </>}
                    </div>
                </DialogContent>
                {/* <DialogActions>
                    <Button onClick={props.handleClose}>Huỷ</Button>
                    <Button onClick={onPressPositive}>{props.type === 'EDIT' ? "Cập nhật" : "Tạo"}</Button>
                </DialogActions> */}
            </Dialog >
        </LocalizationProvider>
    </>);
}

export default ProductOrderDialog;